<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.quotes.detail.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ion-button [attr.aria-label]="'pages.quotes.modal.cancel' | translate" (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ui-current-cdc [project]="project"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <ui-quote-detail
    [showProjectTask]="true"
    [identity]="identity"
    [showStatus]="true"
    [budgetLimit]="budgetLimit"
    [showGenericOverBudgetWarning]="true"
    [insertLabel]="showApprovedDate ? 'pages.quotes.detail.approved' : 'pages.quotes.detail.created'"
    [showBudgetLimit]="false"
    [detail]="_quote"
    [showApprovedDate]="showApprovedDate"
    [showSubtaskBudget]="true"
    [showOverBudgetAmount]="true"
  >
  </ui-quote-detail>
</ion-content>
